/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Rahul Chandra",
  logo_name: "Rahul Chandra",
  nickname: "irahulcse",
  subTitle:
    "A Software Engineer + IAM Consultant with Masters in Computer Science who always thrive to work on end to end products and make the application safe, secure and trustworthy in digital era.",
  resumeLink:
    "https://drive.google.com/file/d/1MiGnlSLRzBhdyArr8Ylw6WCITsy-T3wz/view?usp=drive_link",
  portfolio_repository: "https://github.com/irahulcse",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/irahulcse",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/rahul-chandra-a8371b11b/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:1rahulchandra1@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/1rahulchandra1",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/rahulchandra_99/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Full Stack + Mobile App Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building resposive website front end using React/Next.js/GraphQL",
        "⚡ Developing mobile applications using Flutter and React Native",
        "⚡ Creating application backend in React, GraphQL and Firebase",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "Yarn",
          fontAwesomeClassname: "simple-icons:yarn",
          style: {
            color: "#2C8EBB",
          },
        },
        {
          skillName: "Gatsby",
          fontAwesomeClassname: "simple-icons:gatsby",
          style: {
            color: "#663399",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Worked on different CI/CD tools of cloud platofors like Google Cloud, Microsoft Azure",
        // "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        // "⚡ Deploying deep learning models on cloud(GCP) to use on mobile devices for Machine Learning Projects",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP and Microsoft Azure",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
      ],
    },

    //data science and artificial intelligennce
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Created small models for dynamic forecasting and used in projects.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },

    // {
    //   title: "UI/UX Design and Project",
    //   fileName: "DesignImg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Adobe XD",
    //       fontAwesomeClassname: "simple-icons:adobexd",
    //       style: {
    //         color: "#FF2BC2",
    //       },
    //     },
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E",
    //       },
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00",
    //       },
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000",
    //       },
    //     },
    //   ],
    // },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/1rahulchandra1",
    },
    {
      siteName: "Leetcode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "black",
      },
      profileLink: "https://leetcode.com/irahulcse/",
    },
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "black ",
      },
      profileLink: "http://github.com/irahulcse",
    },
    // {
    //   siteName: "Hackerearth",
    //   iconifyClassname: "simple-icons:hackerearth",
    //   style: {
    //     color: "#323754",
    //   },
    //   profileLink: "https://www.hackerearth.com/@ashutosh391",
    // },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/iamrahulcse",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "SRH University Heidelberg",
      subtitle: "MS in Applied Computer Science (major in Business Computing)",
      logo_path: "srhunilogo.png",
      alt_name: "srh university heidelberg",
      duration: "2024 - 2025",
      descriptions: [
        "⚡ Completed my Masters in Applied Computer Science with major in Business Computing with an top overall grade of 2.1",
        "⚡ Thesis- Enhancing Security through Automated Vulnerability Scanning in Identity Management Systems (Grade 1.3)",
      ],
      website_link: "https://www.srh-university.de/en/our-campuses/heidelberg/",
    },
    {
      title: "University of Stuttgart",
      subtitle:
        "MS in Computer Science (major in Service Technolgy Engineering)",
      logo_path: "unistuttgartlogo.png",
      alt_name: "uni stuttgart thing",
      duration: "2022 - 2024",
      descriptions: [
        "⚡ Currently pursuing a Master's in Computer Science with a major in Service Technology and Engineering at the University Of Stuttgart.",
        "⚡ One of the top 4 Technical universities in the field of Computer Science and Mechanical Engineering in Germany.",
        "⚡ Topic of Thesis: Fine-Grained Energy Profiling of Hierarchical Task Network (HTN) Planners at Function and Instruction Level.",
      ],
      website_link: "https://www.uni-stuttgart.de/",
    },
    {
      title: "Chandigarh University",
      subtitle: "B.E. in Computer Science Engineering",
      logo_path: "chandigarh-university.jfif",
      alt_name: "IIITDM Kurnool",
      duration: "2017 - 2021",
      descriptions: [
        "⚡ First class with distinction - Top 5% of batch.",
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "https://www.cuchd.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link: "https://github.com/irahulcse",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link: "https://github.com/irahulcse",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link: "https://github.com/irahulcse",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "https://github.com/irahulcse",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link: "https://github.com/irahulcse",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link: "https://github.com/irahulcse",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Work Experience",
  subtitle: "SDE Internship and Volunteership",
  description:
    "I have working in both evolving Startups and MNC's as Software Developer, Designer and Mobile App Developer.I love organising events and that is why I am also involved with many opensource communities as a representative.",
  header_image_path: "experience.svg",
  sections: [
    // {
    //   title: "Work",
    //   experiences: [
    //     {
    //       title: "Associate AI Engineer",
    //       company: "Legato Health Technology",
    //       company_url: "https://legatohealthtech.com/",
    //       logo_path: "legato_logo.png",
    //       duration: "June 2020 - PRESENT",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
    //       color: "#0879bf",
    //     },
    //     {
    //       title: "Android and ML Developer",
    //       company: "Muffito Incorporation",
    //       company_url: "https://www.linkedin.com/company/muffito-inc/about/",
    //       logo_path: "muffito_logo.png",
    //       duration: "May 2018 - Oct 2018",
    //       location: "Pune, Maharashtra",
    //       description:
    //         "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
    //       color: "#9b1578",
    //     },
    //     {
    //       title: "Android Developer",
    //       company: "FreeCopy Pvt. Ltd.",
    //       company_url: "https://www.linkedin.com/company/freecopy/about/",
    //       logo_path: "freecopy_logo.png",
    //       duration: "Nov 2017 - Dec 2017",
    //       location: "Ahmedabad, Gujarat",
    //       description:
    //         "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
    //       color: "#fc1f20",
    //     },
    //   ],
    // },
    {
      title: "Full Time Experience",
      experiences: [
        {
          title: "Full Stack Software Engineer / Keycloak IAM Consultant",
          company: "inTension GmBH",
          company_url: "https://www.intension.de/",
          logo_path: "intensionlogo.jpeg",
          duration: "Jan 2025 -present",
          location: "Stuttgart, Germany",
          description:
            "Identity and Access Management: Keycloak Consulting, Keycloak as a Service, Keycloak PLUS",
          color: "#0d8bda",
        },
        {
          title: "Software Engineer - (Devops and Frontend)",
          company: "GroupM GmBH",
          company_url: "https://www.groupm.com/about/?utm_source=linkedin",
          logo_path: "groupm.png",
          duration: "October 2022 -March 2025",
          location: "Dusseldorf, Germany",
          description:
            "GroupM is an umbrella organisation of WPP Inc (the world's largest digital media and marketing agency).",
          color: "#ee3c26",
        },
        {
          title: "Software Engineer Intern - Research and Development",
          company: "Vitrum GmBH",
          company_url: "https://vitrum-connect.de/",
          logo_path: "vitrum.jpeg",
          duration: "June 2022 - Sep 2022",
          location: "Berlin, Germany ",
          description:
            "Currently working on making optimization of artificial irrigation on agriculture land using AI and 5G technology.",
          color: "#170502",
        },
        {
          title: "Student Research Assistant",
          company: "Semanux",
          company_url: "https://www.semanux.com",
          logo_path: "semanux.jpeg",
          duration: "May 2022 - Aug 2022",
          location: "Stuttgart, Germany",
          description: "Contributing to making the web inclusive for all.",
          color: "#0071C5",
        },
        {
          title: "SDE 1 (Frontend and Devops)",
          company: "Zaamo",
          company_url: "https://www.zaamo.co",
          logo_path: "zaamo.jpeg",
          duration: "Sep 2021 - Mar 2022",
          location: "Hauzkhas, New Delhi, India",
          description:
            "Developing an Ecommerce web app in React/Next.js with tech stack as TypeScript, GraphQL and Saleor. In my next stint here, Got a chance to utilize my DevOps skills to bring efficiency to the SDLC. From creating CI/CD pipelines using Github Actions, dockerization, to migrating existing infra from GCP to AWS and adding various analytics services like GA, Amplitude and Hotjar to track user behaviour and gather data and pushing to our backend.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "DevOps Engineer Intern",
          company: "Apop International Pvt Ltd",
          company_url: "https://www.google.com/",
          logo_path: "apop.jpeg",
          duration: "Feb 2021 -Aug, 2021",
          location: "Mumbai, Haryana(Remote)",
          description:
            "Achievement: Single-handedly automated and shifted the entire software and architecture from legacy CtrlS Datacenter/Env's to Microsoft Azure Hybrid Infra via CI/CD, Azure DevOps, etc. Received PPO before the completion of Internship. Leveraged knowledge in ASP.NET, Azure Cloud, and Azure DevOps. Will soon write a blog about my learnings.",
          color: "#e28743",
        },
        {
          title: "SDE Intern",
          company: "Mosaic Wellness",
          company_url: "https://www.mosaicwellness.in/",
          logo_path: "mosaic.jpeg",
          duration: "December 2020 -Feb, 2021",
          location: "Mumbai, Haryana(Remote)",
          description:
            "Contributed to developing Mosaic Manmatters React and Android app.",
          color: "#e28743",
        },
        {
          title: "Full Stack Web  Internship",
          company: "Marsplay Internet Pvt. Ltd.",
          company_url: "https://marsplayapp.com/",
          logo_path: "marsplay.png",
          duration: "August 2020 -Present",
          location: "Gurugram, Haryana",
          description: " ",
          color: "#ee3c26",
        },
        {
          title: "Mobile App Developer/SDE Intern",
          company: "Zypp Mobycy Electric Startup  ",
          company_url: "https://mobycy.com/index.php",
          logo_path: "zypp.png",
          duration: "April 2020-July 2020",
          location: "Remote Work(Lockdown Due to Covid 19)",
          description:
            "This is Electric Mobility Company. I have made a Route Tracking Flutter based Mobile Application(like UBER) to track the User’s journey by GPS and plotted using Google Map.  \n I have built using Flutter/React/Google API's and track the user caleories/behaviour etc. to distinguish there potential work ",
          color: "#0071C5",
        },
        {
          title: "Software Development Internship",
          company: "American Tower Corporation(Fortune 500)",
          company_url: "https://www.americantower.com/",
          logo_path: "americantower.png",
          duration: "May 2019 - July 2019",
          location: "Gurugram, Haryana, India",
          description:
            "American Tower, is a Boston based Fortune 500 MNC, in which I had Designed and Developed a Full Fledged Commercially usable Web Application(Library Management System) using Java Servlets, for over 200 employees. • Created a various dynamic Dashboards/Reports(i.e. Bar Chart, Pie Chart, BoxChart etc.) using JSON and Google Chart API’s.• Full Stack Development Tools used are Java/JSP, Ajax, Git, MySQL, JSON, Servlets, Docker with Project Report in PDF.",
          color: "#0071C5",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Google Explore ML Facilitator",
          company: "Google",
          company_url: "https://about.google/",
          logo_path: "google_logo.png",
          duration: "June 18 - April 2019",
          location: "Mohali, Chandigarh",
          description:
            "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
          color: "#4285F4",
        },
        {
          title: "Microsoft Student Partner",
          company: "Microsoft",
          company_url: "https://www.microsoft.com/",
          logo_path: "microsoft_logo.png",
          duration: "Dec 2019 - July 2020",
          location: "Chandigarh, Mohali",
          description:
            "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
          color: "#D83B01",
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://www.mozilla.org/",
          logo_path: "mozilla_logo.png",
          duration: "Oct 2019 - May 2020",
          location: "Chandigarh, Mohali, Punjab",
          description:
            "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
          color: "#000000",
        },
        {
          title: "Developer Students Club Member",
          company: "GDG Jalandhar",
          company_url:
            "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
          logo_path: "dsc_logo.png",
          duration: "Jan 2018 - May 2020",
          location: "Jalandhar, Punjab",
          description:
            "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
          color: "#0C9D58",
        },
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "July 2019 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating peoper documentation for project.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "rahulchandra.jpg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blog.codemagic.io/how-to-dockerize-flutter-apps/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "C-9, Vikas Vihar, Sector-13, Dwarka-110078",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/MpMqtRZytFchMkZ76",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9217148892",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
